<template>
  <div class="base-layout">
    <el-menu ref="menu" class="base-layout__menu" :default-active="defaultActive" @select="goPath">
      <nav-menu :navMenus="menuData"></nav-menu>
    </el-menu>
    <div :class="['base-layout__content', hasBackground ? 'base-layout__bg' : '']">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import NavMenu from "./SubMenu.vue";
import { getHasPackage } from '@/utils/auth'
export default {
  props: {
    type: { // 选项
      type: Number,
    },
    menuData: {
      // 菜单
      type: Array,
      default: () => [],
    },
    hasBackground: {
      type: Boolean, // 有背景
      default: false,
    },
  },
  components: {
    NavMenu: NavMenu,
  },
  data() {
    return {
      defaultActive: this.menuData[0].path, // 默认的菜单为第一个
    };
  },
  watch: {
    $route: {
      // 监听路由变化
      deep: true,
      immediate: true,
      handler() {
        this.defaultActive = this.$route.path;

      },
    },
  },
  methods: {
    goPath(index, indexPath, item) {
      if (this.type === 2 && getHasPackage() !== 'true') {
        this.$refs.menu.activeIndex = '/pc/official/dialog'
        return
      }

      if (item.$attrs.data && item.$attrs.data.query) {
        this.$router.push({
          path: index,
          query: {
            ...item.$attrs.data.query
          }
        })
        return
      }
      this.$router.push(index)
    },
  }

};
</script>
<style lang="less" scoped>
@menu-hover-color: #fcfaf8;


.base-layout {
  display: flex;
  background: #f5f5fa;

  /deep/&__menu:not(.el-menu--collapse) {
    min-width: 220px;
    min-height: calc(100vh - 112px);
    padding: 10px 0;
    background: #fdfdfd;
    border-right: none;
  }

  /deep/.el-menu-item.is-active {
    background: url(../../assets/img/promotion/slide_active.png);
    background-size: 100% 100%;
    color: #fff;

    i {
      color: #fff;
    }
  }

  /deep/.el-menu-item i {
    color: #666666;
  }

  /deep/.el-submenu__title i {
    color: #666666;
  }

  /deep/.el-menu-item:focus {
    background-color: @menu-hover-color;
  }

  /deep/.el-submenu:hover {
    background-color: @menu-hover-color;
  }

  /deep/.el-menu-item:hover {
    background-color: @menu-hover-color;
  }

  /deep/.el-submenu__title:hover {
    background-color: @menu-hover-color;
  }

  &__content {
    flex: 1;
    margin: 20px 20px 0 20px;
    min-width: 1160px;
    height: calc(100vh - 150px);
    overflow-y: auto;

    &::-webkit-scrollbar-track-piece {
      margin: 8px;
      border-radius: 4px
    }

    &::-webkit-scrollbar {
      width: 7px;
      height: 7px
    }

    &::-webkit-scrollbar-thumb {
      background: #eef0f8;
      border-radius: 4px
    }
  }

  &__bg {
    background: #fff;
    padding: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SliderMenu/index.vue